export function getMfaText(codeDeliveryDestination: string): string {
  return `We sent a 6-digit code to ${codeDeliveryDestination}. If you have trouble accessing this code then`;
}
